<template>
  <div class="refinement-category">
    <div v-show="showTitle" class="title">{{ checkboxFilter.label }}</div>
    <div v-if="toggleAll" class="toggle-all">
      <input
        :id="checkboxAll.id"
        type="checkbox"
        class="tri-state-checkbox"
        :name="checkboxAll.id"
        :value="checkboxAll.state"
        :data-state="checkboxAll.state"
        :aria-label="accessibilityLabel(checkboxAll)"
        :checked="isChecked(checkboxAll.state)"
        @change="checkboxChangeAll(checkboxAll)"
      />
      <label :for="checkboxAll.id">
        {{ checkboxAll.label }}
      </label>
    </div>
    <ul class="refinement-list">
      <li
        v-for="(item, key) in checkboxFilter.items"
        :key="key"
        :class="{
          disabled: checkboxDisabled(item.counter),
        }"
      >
        <input
          :id="item.id"
          type="checkbox"
          class="tri-state-checkbox"
          :name="checkboxFilter.name + '[]'"
          :disabled="checkboxDisabled(item.counter)"
          :value="item.value"
          :data-state="item.state"
          :aria-label="accessibilityLabel(item)"
          :checked="isChecked(item.state)"
          @change="checkboxChange(item)"
        />
        <label :for="item.id">
          {{ itemLabel(item) }}
          <span v-if="enableFacets && !hideOptionCount" class="option-count">{{
            item.counter
          }}</span>
        </label>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
/**
 * Standard and Tri-state checkbox filters
 */
import type { CheckboxFilter, CheckboxFilterItem } from '@/types/search-types'
import { useTriStateCheckboxFilter } from '@/composables/tri-state-checkbox-filter'
import { computed } from 'vue'

/** PROPS **/
const props = withDefaults(
  defineProps<{
    checkboxFilter: CheckboxFilter
    toggleAll?: boolean
    triState?: boolean
    showTitle?: boolean
  }>(),
  {
    toggleAll: false,
    triState: false,
    showTitle: true,
  },
)

/** EMITS **/
const emit = defineEmits(['checkbox-change'])

/** COMPUTED **/
// this is a hack to force a single filter to NOT show it's count
const hideOptionCount = computed(() => props.checkboxFilter.name === 'type')

/** METHODS **/
const {
  accessibilityLabel,
  isChecked,
  checkboxDisabled,
  checkboxChange,
  checkboxAll,
  checkboxChangeAll,
  enableFacets,
} = useTriStateCheckboxFilter({
  checkboxFilter: () => props.checkboxFilter,
  triStateEnabled: () => props.triState,
  debounceCallback: (checkboxItems) => {
    emit('checkbox-change', checkboxItems)
  },
})

function itemLabel(item: CheckboxFilterItem) {
  // hack to remove level from displaying, but we want to keep level for tags
  if (props.checkboxFilter.name === 'difficulty') {
    return item.label.replace('Level', '')
  }

  return item.label
}
</script>
